(() => {
  if (customElements.get('free-shipping-progress')) return;

  class FreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.refreshTimer = null;
      this.handleCartEvent = () => this.queueRefresh();

      document.addEventListener('cart:updated', this.handleCartEvent);
      document.addEventListener('cart:update', this.handleCartEvent);
      document.addEventListener('cart-drawer:open', this.handleCartEvent);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartEvent);
      }

      this.render(Number(this.dataset.total || 0), Number(this.dataset.itemCount || 0));
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.handleCartEvent);
      document.removeEventListener('cart:update', this.handleCartEvent);
      document.removeEventListener('cart-drawer:open', this.handleCartEvent);
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
      if (this.refreshTimer) window.clearTimeout(this.refreshTimer);
    }

    queueRefresh() {
      if (this.refreshTimer) window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refresh(), 80);
    }

    async refresh() {
      try {
        const cartPath = (window.routes && window.routes.cart_url) || '/cart';
        const response = await fetch(cartPath + '.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const cart = await response.json();
        this.render(Number(cart.total_price || 0), Number(cart.item_count || 0));
      } catch (error) {
        // Keep the last server-rendered state if the cart request is interrupted.
      }
    }

    render(total, itemCount) {
      const threshold = Number(this.dataset.threshold || 12000);
      if (threshold <= 0) return;

      this.hidden = itemCount === 0;
      this.dataset.total = String(total);
      this.dataset.itemCount = String(itemCount);

      const remaining = Math.max(threshold - total, 0);
      const progress = Math.min(Math.max((total / threshold) * 100, 0), 100);
      const success = total >= threshold;

      this.classList.toggle('is-success', success);

      const message = this.querySelector('[data-free-shipping-message]');
      if (message) {
        if (success) {
          message.textContent = this.dataset.successTemplate || 'You have unlocked free shipping!';
        } else {
          const amount = this.formatMoney(remaining);
          const template = this.dataset.progressTemplate || 'You are {{ amount }} away from free shipping.';
          message.textContent = template.replace(/\{\{\s*amount\s*\}\}/g, amount);
        }
      }

      const fill = this.querySelector('[data-free-shipping-fill]');
      if (fill) fill.style.width = progress + '%';

      const track = this.querySelector('[data-free-shipping-track]');
      if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));

      const recommendation = this.querySelector('[data-free-shipping-recommendation]');
      if (recommendation) recommendation.hidden = success;

      const checkmark = this.querySelector('.free-shipping-progress__checkmark');
      if (checkmark) checkmark.hidden = !success || this.dataset.showCheckmark !== 'true';
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || 'USD';
      const locale = document.documentElement.lang || 'en-US';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(cents / 100);
    }
  }

  customElements.define('free-shipping-progress', FreeShippingProgress);
})();
